export function convertToFormatjsFormats(formats) {
  const formatjsFormats = {
    dateTimeRange: formats['format-date-range'],
    date: formats['format-date'],
    number: formats['format-number'],
    relative: formats['format-relative-time'],
    time: formats['format-time']
  };
  return formatjsFormats;
}